import { h } from "preact";

import { Button, DialogActions, DialogContent, Dialog, DialogTitle, Typography } from "@mui/material";

import ConfirmPhone from "../ConfirmPhone";
export default function VerificationPhoneCodeDialog({ state, onClose }) {
	const handleClose = () => {
		onClose();
	};

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={state.open} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5" gutterBottom>
					Vérification du téléphone
				</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<ConfirmPhone />
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={onClose}>
					Fermer
				</Button>
			</DialogActions>
		</Dialog>
	);
}
